import {
    CREATE_FILTER_REQUEST,
    CREATE_FILTER_SUCCESS,
    CREATE_FILTER_FAILURE,
    DELETE_FILTER_REQUEST,
    DELETE_FILTER_SUCCESS,
    DELETE_FILTER_FAILURE,
    FETCH_SINGLE_FILTER_REQUEST,
    FETCH_SINGLE_FILTER_SUCCESS,
    FETCH_SINGLE_FILTER_FAILURE,
    FETCH_FILTER_REQUEST,
    FETCH_FILTER_SUCCESS,
    FETCH_FILTER_FAILURE,
    UPDATE_FILTER_REQUEST,
    UPDATE_FILTER_SUCCESS,
    UPDATE_FILTER_FAILURE,
    RESET_FILTER_INFO,
    CREATE_FILTER_FORM,
    UPDATE_FILTER_FORM
} from './filter.actionsType';

export const FILTER = 'filter';

let initialState = {
    loading: false,
    filterList: [],
    filterForm: {
        fldContains: true,
        fldNotContains: false
    },
    selectedState: {},
    errorMessage: ''
};

export let filterReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_FILTER_REQUEST:
        case CREATE_FILTER_REQUEST:
        case UPDATE_FILTER_REQUEST:
        case FETCH_SINGLE_FILTER_REQUEST:
        case DELETE_FILTER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_FILTER_SUCCESS:
            return {
                ...state,
                loading: false,
                filterList: updatePayload
            };
        case CREATE_FILTER_SUCCESS:
            return {
                ...state,
                loading: false,
                filterForm: {
                    fldContains: true,
                    fldNotContains: false
                }
            };
        case UPDATE_FILTER_SUCCESS:
            return {
                ...state,
                loading: false,
                filterForm: {
                    fldContains: true,
                    fldNotContains: false
                }
            };
        case FETCH_SINGLE_FILTER_SUCCESS:
            return {
                ...state,
                loading: false,
                filterForm: {
                    ...updatePayload
                }
            };
        case DELETE_FILTER_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case RESET_FILTER_INFO:
            return {
                ...state,
                filterForm: {
                    fldContains: true,
                    fldNotContains: false
                }
            };
        case CREATE_FILTER_FORM:
        case UPDATE_FILTER_FORM:
            return {
                ...state,
                loading: false,
                filterForm: {
                    ...state.filterForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_FILTER_FAILURE:
        case CREATE_FILTER_FAILURE:
        case UPDATE_FILTER_FAILURE:
        case FETCH_SINGLE_FILTER_FAILURE:
        case DELETE_FILTER_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
